import { useAppSelector } from '../../hooks/useAppSelector'
import { selectOneProductUtcOffset } from '../../store/selectors/productsUtcOffsetSelectors'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import React, { memo, useEffect, useState } from 'react'
import { getProductTime } from '../../utils/getProductTime'
import { useInitialEffect } from '../../hooks/useInitialEffect'
import { fetchUtcOffset } from '../../store/async-thunks/utcOffset/fetchUtcOffset'
import styles from './ProductTime.module.scss'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface ProductTimeProps {
    guid: string
    className?: string
}

export const ProductTime = memo(function ProductTime(props: ProductTimeProps) {
    const { guid, className } = props
    const dispatch = useAppDispatch()

    const [datetime, setDatetime] = useState('Loading...')
    const productUtcOffset = useAppSelector(selectOneProductUtcOffset(guid))

    useInitialEffect(() => {
        dispatch(fetchUtcOffset({ productId: guid }))
    })

    useEffect(() => {
        const timeInterval = setInterval(() => {
            const productTime = getProductTime(productUtcOffset)
            setDatetime(productTime ?? '')
        }, 1000)

        return () => {
            clearInterval(timeInterval)
        }
    }, [productUtcOffset])

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Product local time</Tooltip>}
        >
            <div className="d-flex gap-2 align-items-center">
                <div className={`${styles.datetime} ${className}`}>
                    {datetime}
                </div>
            </div>
        </OverlayTrigger>
    )
})
